import NormalDialog from './NormalDialog'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function(Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(NormalDialog)

    //2.用new 的方式用组件构造器创建出来组件对象
    const normalDialog = new Construct({ router, store })

    //3.将组件对象手动挂载到某一个元素上
    normalDialog.$mount(document.createElement('div'))

    //4.upperTip.$el对应的就是div
    document.body.appendChild(normalDialog.$el)

    //5.在原型中加入UpperTip
    Vue.prototype.$NormalDialog = normalDialog
}

export default obj
